import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgFaceGlyphSecondary from './svgs/FaceGlyphSecondary.js';
import SvgFaceGlyph from './svgs/FaceGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var faceGlyph = (props => useIcon(SvgFaceGlyph, SvgFaceGlyphSecondary, props));

export { faceGlyph as default };
